import { useMemo, useState } from 'react'
import ExpedicaoTpsHttp from '../../../../services/api/https/dashboard/expedicao-tps.http'
import { getCompaniesGroupAssociatedToUser } from '../../../../services/api/https/system/system.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

const vehicleFields = {
  vehicle_badge: 'Placa',
  driver_name: 'Motorista',
  nome_motorista: 'Motorista',
  data_chegada: 'Data Chegada',
  data_operacao: 'Data Operação',
  codigo_lacre: 'Código Lacre',
  horario_chegada: 'Horário Chegada',
  motivo_atraso: 'Motivo de Atraso',
  horario_saida: 'Horario Saida',
  data_prevista_carregamento: 'Data Operação',
  qte_caixas: 'Qte. Caixas',
}

const entregaFields = {
  bairro: 'Bairro',
  cidade: 'Cidade',
  company_name: 'Empresa',
  data_operacao: 'Data Operação',
  identifier: 'Identificador',
  nomeFantasia: 'Cliente',
  quantidade_caixas: 'Qte. Caixas',
  tp_name: 'Op. Logístico',
}

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FETCH_INITIAL_INFO: 'Adquirindo grupos de empresas',
  GET_INFO: 'Adquirindo informações . . . isso pode demorar mais tempo do que o normal',
}

const INITIAL_DASHBOARD_INFO = {
  expedicoes: [],
  total_t1_atrasados: 0,
  total_t2_atrasados: 0,
  total_entregas_paradas: 0,
  motivos_graph_data: {
    t1: [],
    t2: [],
  },
}

const INITIAL_STATE = {
  periodo: { dataInicial: new Date(), dataFinal: new Date() },
  companiesGroups: [],
  companiesGroupSelected: [],
  dashboardInfo: { ...INITIAL_DASHBOARD_INFO },
  modalInfo: {
    fields: [],
    data: [],
    title: '',
    show: false,
    typeModal: 'veiculos',
    width: 600,
    fieldParser: {},
  },
  colors: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useExpedicaoTps() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const throwError = message => {
      setState(prevState => ({ ...prevState, errorMessage: message }))
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getCompaniesGroupAssociatedToUser() {
        getCompaniesGroupAssociatedToUser(getUsuarioInfo().id)
          .then(response =>
            setState(prevState => ({
              ...prevState,
              companiesGroups: response.map(c => ({
                label: c.company_group_name,
                value: c.company_group_id,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getExpedicaoTpsInfo(pInicial, pFinal, companiesGroupSelected, selectedTp) {
        const tpsIds = []
        if (selectedTp) tpsIds.push(selectedTp)
        else
          tpsIds.push(
            getTps(false)
              .map(tp => tp.id)
              .toString(),
          )
        ExpedicaoTpsHttp.getExpedicaoTps(
          pInicial,
          pFinal,
          companiesGroupSelected.toString(),
          tpsIds,
        )
          .then(data => {
            const tWithMostNumberOfReasons =
              data.motivos_graph_data.t1.length > data.motivos_graph_data.t2.length
                ? data.motivos_graph_data.t1
                : data.motivos_graph_data.t2
            setState(prevState => ({
              ...prevState,
              dashboardInfo: data,
              colors: tWithMostNumberOfReasons.map(this.generateColorsToGraph),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      generateColorsToGraph() {
        return (
          '#' +
          parseInt(Math.random() * 0xffffff)
            .toString(16)
            .padStart(3, '0')
        )
      },

      //Events
      onCompanieGroupChange(idsCompaniesSelected) {
        setState(prevState => ({ ...prevState, companiesGroupSelected: idsCompaniesSelected }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modalInfo: { ...INITIAL_STATE.modalInfo } }))
      },

      onClickOpenModal(typeModal, value) {
        switch (typeModal) {
          case 'carros_t1_atrasados_items':
            if (value.modal_infos.carros_t1_atrasados_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.carros_t1_atrasados_items,
                  fields: Object.keys(value.modal_infos.carros_t1_atrasados_items[0]),
                  show: true,
                  title: 'Veiculos Atrasados T1',
                  width: 800,
                  fieldParser: vehicleFields,
                },
              }))
            break
          case 'carros_t2_parados_items':
            if (value.modal_infos.carros_t2_parados_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.carros_t2_parados_items,
                  fields: Object.keys(value.modal_infos.carros_t2_parados_items[0]),
                  show: true,
                  title: 'Veiculos Parados T2',
                  width: 700,
                  fieldParser: vehicleFields,
                },
              }))
            break
          case 'carros_t2_atrasados_items':
            if (value.modal_infos.carros_t2_atrasados_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.carros_t2_atrasados_items,
                  fields: Object.keys(value.modal_infos.carros_t2_atrasados_items[0]),
                  show: true,
                  title: 'Veiculos Atrasados T2',
                  width: 700,
                  fieldParser: vehicleFields,
                },
              }))
            break
          case 'entregas_paradas_items':
            if (value.modal_infos.entregas_paradas_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.entregas_paradas_items,
                  fields: Object.keys(value.modal_infos.entregas_paradas_items[0]),
                  show: true,
                  title: 'Entregas Paradas',
                  width: 1000,
                  fieldParser: entregaFields,
                },
              }))
            break
          case 'carros_t2_roteirizados_items':
            if (value.modal_infos.carros_t2_roteirizados_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.carros_t2_roteirizados_items,
                  fields: Object.keys(value.modal_infos.carros_t2_roteirizados_items[0]),
                  show: true,
                  title: 'Carros Roteirizados',
                  width: 500,
                  fieldParser: vehicleFields,
                },
              }))
            break
          case 'carros_t2_enviados_items':
            if (value.modal_infos.carros_t2_enviados_items.length === 0)
              throwError('Não existem items a serem exibidos')
            else
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.carros_t2_enviados_items,
                  fields: Object.keys(value.modal_infos.carros_t2_enviados_items[0]),
                  show: true,
                  title: 'Carros Enviados',
                  width: 700,
                  fieldParser: vehicleFields,
                },
              }))
            break
          default:
            break
        }
      },

      onSearchDashboardInfo(companieGroupSelected, pInicial, pFinal) {
        if (!companieGroupSelected.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um grupo de empresas para gerar os dados',
          }))
        else
          setState(prevState => ({
            ...prevState,
            periodo: { dataInicial: pInicial, dataFinal: pFinal },
            loadingMessage: LOAD_MESSAGE.GET_INFO,
          }))
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.FETCH_INITIAL_INFO }))
      },
    }
  }, [])

  return { state, localDispatch }
}
